// import React, { useState } from "react";
// import { Card, CardContent, Typography, MenuItem, Select, SelectChangeEvent, Box } from "@mui/material";
// import { Bar } from "react-chartjs-2";
// import { 
//   Chart, 
//   CategoryScale, 
//   LinearScale, 
//   BarElement, 
//   Title, 
//   Tooltip, 
//   Legend, 
//   PointElement, 
//   LineElement // ✅ Fix: Register LineElement
// } from "chart.js";
// import { ChartOptions } from "chart.js";

// Chart.register(
//   CategoryScale, 
//   LinearScale, 
//   BarElement, 
//   Title, 
//   Tooltip, 
//   Legend, 
//   PointElement, 
//   LineElement // ✅ Register LineElement to fix the error
// );



// const BarChartCard: React.FC<{ title: string; }> = ({ title }) => {
//   const [timeframe, setTimeframe] = useState("month"); // Default: Monthly Sales

//   // Data for different timeframes
//   const salesData: Record<string, { labels: string[]; data: number[] }> = {
//     week: {
//       labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
//       data: [50, 80, 40, 90, 120, 150, 130],
//     },
//     month: {
//       labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
//       data: [400, 550, 700, 850],
//     },
//     quarter: {
//       labels: ["Q1", "Q2", "Q3", "Q4"],
//       data: [2000, 3000, 3500, 4000],
//     },
//     year: {
//       labels: ["2022", "2023", "2024", "2025"],
//       data: [8000, 10000, 12000, 15000],
//     },
//   };

//   // Handle timeframe change
//   const handleChange = (event: SelectChangeEvent) => {
//     setTimeframe(event.target.value);
//   };

//   // Chart data based on selected timeframe
//   const data = {
//     labels: salesData[timeframe].labels,
//     datasets: [
//       {
//         label: "Sales",
//         data: salesData[timeframe].data,
//         backgroundColor: ["#4caf50", "#ff9800", "#03a9f4", "#e91e63", "#9c27b0"],
//         borderColor: "#ffffff",
//         borderWidth: 1,
//       },
//     ],
//   };

//   // Chart options
//   const options: ChartOptions<"bar"> = {
//     responsive: true,
//     plugins: {
//       legend: { display: false },
//     },
//     scales: {
//       y: { beginAtZero: true },
//       x: { ticks: { display: true } },
//     },
//   };

//   return (
//     <Card sx={{ borderRadius: 1, padding: 0 }}>
//       <CardContent>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginBottom: 2 }}>
//           <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//             {title}
//           </Typography>
//           <Select
//             value={timeframe}
//             onChange={handleChange}
//             variant="outlined"
//             size="small"
//             sx={{ width: "150px", marginLeft: "auto" }}
//           >
//             <MenuItem value="week">Week</MenuItem>
//             <MenuItem value="month">Month</MenuItem>
//             <MenuItem value="quarter">Quarter</MenuItem>
//             <MenuItem value="year">Year</MenuItem>
//           </Select>
//         </Box>

//         {/* Bar Chart */}
//         <Bar data={data} options={options} />
//       </CardContent>
//     </Card>
//   );
// };

// export default BarChartCard;
//LM

//import { getSalesPerformance } from  "../../../Services/DashboardService";
import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, MenuItem, Select, SelectChangeEvent, Box } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from "chart.js";
import { getSalesPerformance } from  "../../../Services/DashboardService";

Chart.register(
  CategoryScale, 
  LinearScale, 
  BarElement, 
  Title, 
  Tooltip, 
  Legend, 
  PointElement, 
  LineElement
);

// Define the type for the sales data state
type SalesData = {
  labels: string[];
  data: number[];
};

const BarChartCard: React.FC<{ title: string; orgId: string }> = ({ title, orgId }) => {
  const [timeframe, setTimeframe] = useState("month"); // Default: Monthly Sales
  const [salesData, setSalesData] = useState<SalesData>({ labels: [], data: [] }); // Define state with SalesData type

  // Handle timeframe change
  const handleChange = (event: SelectChangeEvent) => {
    setTimeframe(event.target.value);
  };

  // Fetch sales performance data
  const fetchSalesData = async () => {
    try {
      const response = await getSalesPerformance(orgId, timeframe);
      const { salesData: fetchedSalesData } = response.data;

      // Prepare the labels and data depending on the timeframe
      let formattedSalesData: SalesData = { labels: [], data: [] };
      //By Week
      if (timeframe === "week") {
        const today = new Date();
      
        // Convert today to IST (UTC+5:30)
        const todayIST = new Date(today.getTime() + (5.5 * 60 * 60 * 1000));
      
        // Get last week's Monday in IST
        const currentMondayIST = new Date(todayIST);
        currentMondayIST.setDate(todayIST.getDate() - todayIST.getDay() + 1);
        currentMondayIST.setHours(0, 0, 0, 0);
      
        const lastMondayIST = new Date(currentMondayIST);
        lastMondayIST.setDate(currentMondayIST.getDate() - 7);
      
        const lastSundayIST = new Date(lastMondayIST);
        lastSundayIST.setDate(lastMondayIST.getDate() + 6);
        lastSundayIST.setHours(23, 59, 59, 999);
        const salesByDay = [0, 0, 0, 0, 0, 0, 0]; // Mon-Sun
      
        fetchedSalesData.forEach((invoice: { invoiceDate: string | number | Date; totalAmount: number; }) => {
          const invoiceDate = new Date(invoice.invoiceDate); // API returns UTC
      
          // Convert invoiceDate to IST
          const invoiceISTDate = new Date(invoiceDate.getTime() + (5.5 * 60 * 60 * 1000));
      
          // Only count invoices from last week's Monday to Sunday
          if (invoiceISTDate >= lastMondayIST && invoiceISTDate <= lastSundayIST) {
            let dayOfWeek = invoiceISTDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
            const index = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Shift so Monday is first
      
            salesByDay[index] += invoice.totalAmount;
      
            console.log(
              "Invoice Date (IST):",
              invoiceISTDate.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
              " | Mapped Index:",
              index,
              " | Amount:",
              invoice.totalAmount
            );
          }
        });
      
        formattedSalesData = {
          labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          data: salesByDay,
        };
      
        console.log("Formatted Sales Data for Last Week (IST):", formattedSalesData);
      }
      
      if (timeframe === "month") {
        // Sales by week in a month (Week 1, Week 2, Week 3, Week 4)
        const weeklySales = [0, 0, 0, 0]; // Week 1, Week 2, Week 3, Week 4
        fetchedSalesData.forEach((invoice: { invoiceDate: string | number | Date; totalAmount: number; }) => {
          const invoiceDate = new Date(invoice.invoiceDate);
          const weekOfMonth = Math.floor(invoiceDate.getDate() / 7); // Week of the month (0, 1, 2, 3)
          weeklySales[weekOfMonth] += invoice.totalAmount;
        });
        formattedSalesData = {
          labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
          data: weeklySales,
        };
      }

      if (timeframe === "quarter") {
        // Sales by Indian financial year quarters (Q1: Apr-Jun, Q2: Jul-Sep, Q3: Oct-Dec, Q4: Jan-Mar)
        const quarterlySales = [0, 0, 0, 0]; // Q1-Q4 based on Indian FY
      
        fetchedSalesData.forEach((invoice: { invoiceDate: string | number | Date; totalAmount: number; }) => {
          const invoiceDate = new Date(invoice.invoiceDate);
          const month = invoiceDate.getMonth(); // Get the month (0 = Jan, 11 = Dec)
          const financialQuarter = Math.floor(((month + 9) % 12) / 3); // Adjust to Apr-Mar quarters
        
          console.log(`Invoice Date: ${invoiceDate.toISOString()}, Month: ${month}, Quarter: ${financialQuarter}`);
          
          quarterlySales[financialQuarter] += invoice.totalAmount;
        });
      
        formattedSalesData = {
          labels: ["Q1 (Apr-Jun)", "Q2 (Jul-Sep)", "Q3 (Oct-Dec)", "Q4 (Jan-Mar)"],
          data: quarterlySales,
        };
      }
      
      if (timeframe === "year") {
        const currentYear = new Date().getFullYear(); // Define currentYear
          const yearlySales: Record<number, number> = {
          [currentYear - 3]: 0, 
          [currentYear - 2]: 0, 
          [currentYear - 1]: 0, 
          [currentYear]: 0
        };
      
        fetchedSalesData.forEach((invoice: { invoiceDate: string | number | Date; totalAmount: number }) => {
          const invoiceDate = new Date(invoice.invoiceDate);
          const invoiceYear = invoiceDate.getFullYear();
      
          if (yearlySales.hasOwnProperty(invoiceYear)) {
            yearlySales[invoiceYear] += invoice.totalAmount;
          }
        });
      
        formattedSalesData = {
          labels: Object.keys(yearlySales), // ["2022", "2023", "2024", "2025"]
          data: Object.values(yearlySales) // [TotalSales2022, TotalSales2023, TotalSales2024, TotalSales2025]
        };
      
        console.log("Formatted Sales Data for Yearly View:", formattedSalesData);
      }      
      setSalesData(formattedSalesData); // Update the state with the new data
    } catch (error) {
      console.error("Failed to fetch sales performance data", error);
    }
  };

  // Call fetchSalesData whenever the timeframe or orgId changes
  useEffect(() => {
    fetchSalesData();
  }, [timeframe, orgId]); // Dependency on timeframe and orgId

  // Chart data based on fetched salesData
  const data = {
    labels: salesData.labels,
    datasets: [
      {
        label: "Sales",
        data: salesData.data,
        backgroundColor: ["#4caf50", "#ff9800", "#03a9f4", "#e91e63", "#9c27b0"],
        borderColor: "#ffffff",
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: { beginAtZero: true },
      x: { ticks: { display: true } },
    },
  };

  return (
    <Card sx={{ borderRadius: 1, padding: 0 }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginBottom: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
          <Select
            value={timeframe}
            onChange={handleChange}
            variant="outlined"
            size="small"
            sx={{ width: "150px", marginLeft: "auto" }}
          >
            <MenuItem value="week">Week</MenuItem>
            <MenuItem value="month">Month</MenuItem>
            <MenuItem value="quarter">Quarter</MenuItem>
            <MenuItem value="year">Year</MenuItem>
          </Select>
        </Box>

        {/* Bar Chart */}
        <Bar data={data} options={options} />
      </CardContent>
    </Card>
  );
};

export default BarChartCard;
